var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLotsUnitsDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_466",
    "data-name": "Group 466",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.5,
    height: 37.509,
    viewBox: "0 0 37.5 37.509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_760",
    "data-name": "Rectangle 760",
    width: 37.5,
    height: 37.509,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M21.313,0a1.04,1.04,0,0,1,.573,1.079q-.011,17.153-.006,34.306v.535H34.347c.007-.125.022-.253.022-.38q0-9.9.008-19.808a.489.489,0,0,0-.358-.533q-4.929-2.1-9.849-4.213c-.078-.034-.159-.062-.236-.1A.775.775,0,0,1,23.5,9.856a.765.765,0,0,1,1.037-.4c.845.347,1.682.714,2.522,1.074l8.1,3.468c.688.294.784.437.784,1.185q0,10.123,0,20.247v.509c.586.036,1.23-.127,1.556.544v.439a.979.979,0,0,1-1.026.592Q18.754,37.5,1.033,37.5a2.416,2.416,0,0,1-.365-.011A.784.784,0,0,1,0,36.7a.766.766,0,0,1,.719-.741c.158-.013.317-.008.476-.008H3.129v-.513q0-14.078,0-28.155c0-.668.12-.837.726-1.057Q10.519,3.8,17.181,1.376C18.415.926,19.643.459,20.873,0h.439M4.686,35.921h15.6v-34c-.171.055-.32.1-.466.152Q12.455,4.756,5.085,7.43a.5.5,0,0,0-.408.554q.016,13.769.009,27.539Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M256.953,193.979c0,.487.007.974,0,1.461a.791.791,0,1,1-1.57.009q-.012-1.461,0-2.922a.789.789,0,1,1,1.569-.009c.011.487,0,.974,0,1.461",
    transform: "translate(-230.386 -172.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M303.3,193.972c0-.475-.006-.95,0-1.424a.8.8,0,0,1,.8-.9.794.794,0,0,1,.774.882q.014,1.461,0,2.922a.794.794,0,0,1-.777.879c-.468.005-.785-.347-.793-.9-.008-.487,0-.974,0-1.461",
    transform: "translate(-273.62 -172.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M255.391,289.8c0-.487-.007-.974,0-1.461a.8.8,0,0,1,.777-.879.788.788,0,0,1,.791.863q.016,1.479,0,2.958a.788.788,0,0,1-.794.861.805.805,0,0,1-.776-.882c0-.024,0-.049,0-.073q0-.694,0-1.388",
    transform: "translate(-230.398 -259.335)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M303.3,289.789c0-.475-.006-.95,0-1.424.009-.553.325-.9.794-.9a.793.793,0,0,1,.776.879q.014,1.461,0,2.922a.794.794,0,0,1-.775.881.8.8,0,0,1-.8-.9c-.008-.487,0-.974,0-1.461",
    transform: "translate(-273.62 -259.336)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M161.141,98.169c0,.487.007.974,0,1.461a.791.791,0,1,1-1.57.006q-.012-1.461,0-2.922a.789.789,0,1,1,1.569-.006c.011.487,0,.974,0,1.461",
    transform: "translate(-143.949 -86.462)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M161.135,194c0,.487.009.974,0,1.461a.789.789,0,1,1-1.569.006q-.015-1.479,0-2.958a.786.786,0,1,1,1.567-.006c.013.5,0,1,0,1.5",
    transform: "translate(-143.944 -172.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M161.141,289.816c0,.487.008.974,0,1.461a.789.789,0,1,1-1.569-.005q-.014-1.461,0-2.922a.8.8,0,0,1,.769-.887c.471-.01.785.34.8.892,0,.024,0,.049,0,.073q0,.694,0,1.388",
    transform: "translate(-143.949 -259.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M81.412,98.2c0,.487,0,.974,0,1.46a.8.8,0,0,1-.786.865.775.775,0,0,1-.766-.843q-.012-1.5,0-2.993a.776.776,0,0,1,.762-.846.793.793,0,0,1,.79.861c.006.5,0,1,0,1.5",
    transform: "translate(-72.039 -86.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M79.867,193.986c0-.5-.007-1,0-1.5a.778.778,0,1,1,1.551-.007q.012,1.515,0,3.03a.781.781,0,0,1-.792.821.773.773,0,0,1-.757-.814c-.011-.511,0-1.022,0-1.533",
    transform: "translate(-72.05 -172.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M81.412,289.838c0,.487.006.974,0,1.46a.792.792,0,0,1-.771.844.776.776,0,0,1-.78-.829q-.013-1.515,0-3.03a.771.771,0,0,1,.782-.825.791.791,0,0,1,.768.846c.007.511,0,1.022,0,1.533",
    transform: "translate(-72.039 -259.329)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLotsUnitsDetails);
export default __webpack_public_path__ + "static/media/icon-lots-units-details.e5b5520fe609d177e8d9facf1110620d.svg";
export { ForwardRef as ReactComponent };